/**
 * Please maintain the list in alphabetical order
 */
const APIEndpoints = {
  bulkOperations: '/api/v4/tenants/%(tenantId)s/operations',
  bulkOperationsV5: '/api/v5/BulkOperations',
  checkWorkflowInProgress: '/bffapi/v1/AutoSubmission/check-in-progress',
  closeReturn: '/api/v6/filing/CloseReturn',
  closeVatBook: '/api/v4/filing/types/vatbook/close',
  createReturns: '/api/returns',
  creditNoteCertificate: '/api/v3/transaction/errors/CreditNoteCertificate',
  creditNoteCertificateV5: '/api/v5/transaction/errors/CreditNoteCertificate',
  deleteCompany: '/bffapi/v2/companies/{0}',
  getApiLicenseKey: '/api/v6/LicenseKeys',
  getBulkOperationStatus: '/operations/api/tenants/%(tenantId)s/Operations',
  createBulkOperation: '/operations/api/tenants/%(tenantId)s/Operations',
  getCanUserSaveToWorkflow: '/api/reports/CanUserSaveToWorkflow',
  getCompanies: '/api/Companies',
  getCompaniesSummaryV3: '/api/v3/companies/summary',
  getCompaniesV2: '/api/v2/Companies',
  getCompanyDetails: '/api/Companies/%(id)s',
  getCompanyDetailsV4: '/api/V4/Companies/%(id)s',
  getCompanyPermissions: '/permissions-service-api/v1/tenants/%(tenantId)s/TenantCompanyGrants',
  getContentEnum: '/api/content/enums?name=frequency&name=eucountry&name=country&name=modeoftransport&name=deliverycondition&name=transactiontype&name=listinglinetype',
  getCountriesOnHold: '/api/Countries',
  getDynamicReportsData: '/api/v3/dynamicReports/%(reportType)s',
  getDynamicReportsDataV4: '/api/v4/dynamicReports/%(reportType)s',
  getEntitlements: '/bffapi/v1/Entitlements',
  getErrorCategories: '/api/transaction/errors/categories',
  getErrorDetail: '/api/transaction/errors/%(id)s',
  getErrorSubCategories: '/api/transaction/errors/subcategories',
  getErrors: '/api/transaction/errors',
  getExchangeRates: '/api/ExchangeRates',
  getExchangeRatesFiltered: '/api/ExchangeRates/filtered',
  getExchangeRatesExportCsv: '/api/v5/exchangeRates/export/csv',
  getFilingObligations: '/api/filing/obligations',
  getFilingValueDetails: '/api/filing/types/vat/%(companyId)s/values/%(boxName)s',
  getIamTenantInfo: '/api/Content/IamTenantInfo',
  getIntrastatCommercialSummary: '/api/v4/filing/types/intrastat/total/%(companyId)s/%(countryCode)s/%(intrastatReportType)s/%(startDate)s/%(endDate)s',
  getIntrastatDetails: '/api/filing/types/intrastat/values',
  getOpenReturns: '/api/v2/OpenReturns',
  getProcessingStats: '/api/processing/stats',
  getReopenableClosedReturns: '/api/v1/Reports/ReopenableClosedReturns',
  getReport: '/api/filing/types',
  getReportLatest: '/api/v4/filing/types',
  getReportSpecifications: '/api/v3/dynamicReports/specification',
  getReportSpecificationsV4: '/api/v4/dynamicReports/specification',
  getReportSpecificationsV5: '/api/v5/dynamicReports/specification',
  getLatestDynamicReportDefinitions: '/dynamic-reports/definitions',
  getLatestDynamicReportsData: '/dynamic-reports/$generate',
  getLatestDynamicReportExport: '/dynamic-reports/$export',
  getReturnApprovalStatus: '/api/v6/ReturnApprovals/Status',
  getReturnRawFormXml: '/api/v6/Returns/%(guid)s/rawformxml',
  getReturns: '/api/returns',
  getReturnsDocument: '/api/Returns/%(guid)s',
  getReturnsForAI: '/api/returns',
  getRoles: '/api/roles',
  getRolesByUserId: '/api/UserRoles/%(userId)s',
  getSalesPurchaseLedgers: '/api/v3/ledger',
  getWarningCategories: '/api/transaction/warnings/categories',
  getWarningDetail: '/api/transaction/warnings/%(id)s',
  getWarningSubCategories: '/api/transaction/warnings/subcategories',
  getWarnings: '/api/transaction/warnings',
  initiateAutoSubmission: '/bffapi/v1/AutoSubmission/initiate',
  saveToWorkflow: '/api/reports/SaveToWorkflow',
  sendReturnForApproval: '/api/v6/ReturnApprovals',
  unlockCountryOnHold: '/api/Countries',
  updateBoxValueAutoCorrectFlag: '/api/Returns/udpateBoxValueAutoCorrectFlag',
  updateCompanyPermissionsForUser: '/permissions-service-api/v1/tenants/%(tenantId)s/users/%(userId)s/companyGrants',
};

export default Object.freeze(APIEndpoints);
